import { useEffect } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { observer } from 'mobx-react-lite'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Credits } from 'blaze-ui/icons/20/Credits'
import Styles from '../VisualStylesForExistingUsersModal.module.scss'
import { trackEventInHeap, HeapEventType } from 'utils/heapTracking'
import { useCreditUsage } from 'hooks/useCreditUsage'

interface IntroStepProps {
  onNext: () => void
}

export const IntroStep = observer(({ onNext }: IntroStepProps) => {
  const { closeModal } = useModals()
  const { usageCosts } = useCreditUsage()

  useEffect(() => {
    trackEventInHeap(HeapEventType.VisualStylesForExistingUsers, {
      action: 'view-intro-step',
    })
  }, [])

  return (
    <>
      <Modal.Header title="✨ What's New" />
      <Modal.Content>
        <div className={Styles.introContent}>
          <img
            src="https://res.cloudinary.com/almanac/image/upload/v1767967966/blaze_assets/content_preferences/Frame_1171275087_a5vuuf.webp"
            alt="Visual Styles Introduction"
            className={Styles.heroImage}
          />
          <Heading level={3}>Turn on stylized images and videos to create on-brand content that performs.</Heading>
          <div className={Styles.featuresGrid}>
            <div className={Styles.featureColumn}>
              <div className={Styles.featureHeader}>
                <Heading level={5}>Stylized Images</Heading>
              </div>
              <Text color="var(--dark-80)">Pick a professional-grade Visual Style to keep every image consistent.</Text>
              <div className={Styles.featureIconContainer}>
                <Credits size={12} color="var(--dark-40)" />
                <Text variant="secondary" color="var(--dark-40)">
                  {usageCosts?.visual_styles_credits_cost} credits per image
                </Text>
              </div>
            </div>
            <div className={Styles.featureColumn}>
              <div className={Styles.featureHeader}>
                <Heading level={5}>AI Videos</Heading>
              </div>
              <Text color="var(--dark-80)">Turn static images into compelling 8-second videos.</Text>
              <div className={Styles.featureIconContainer}>
                <Credits size={12} color="var(--dark-40)" />
                <Text variant="secondary" color="var(--dark-40)">
                  {usageCosts?.video_credits_cost} credits per video
                </Text>
              </div>
            </div>
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="tertiary" size="lg" onPress={closeModal}>
            Close
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button variant="primary" size="lg" onPress={onNext}>
            Enable and Pick My Visual Style
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
})
